module.exports = __webpack_public_path__ + "img/icon_patent.9017cf23.png";